import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useDashboardTab(defaultTab: string, validTabs: readonly string[]) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('tab') ?? '';
  const activeTab = validTabs.includes(tabParam) ? tabParam : defaultTab;

  const setActiveTab = useCallback(
    (tab: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          if (tab === defaultTab) next.delete('tab');
          else next.set('tab', tab);
          return next;
        },
        { replace: true },
      );
    },
    [defaultTab, setSearchParams],
  );

  return { activeTab, setActiveTab, searchParams, setSearchParams };
}
